import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=1a97b7ec&scoped=true&lang=pug&"
import script from "./scripts/AppHeader.js?vue&type=script&lang=js&"
export * from "./scripts/AppHeader.js?vue&type=script&lang=js&"
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=1a97b7ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a97b7ec",
  null
  
)

export default component.exports